const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  name: state => state.user.name,
  nameEn: state => state.user.nameEn,
  phone: state => state.user.phone,
  email: state => state.user.email,
  userId: state => state.user.userId,
  conferenceId: state => state.user.conferenceId,
  type: state => state.user.type,
  peopleType: state => state.user.peopleType,
  needUpdateInfo: state => state.user.needUpdateInfo,
  status: state => state.user.status,
  promiseHealth: state => state.user.promiseHealth,
  userInfo: state => state.user,
  joinState: state => state.user.joinState,
  signState: state => state.user.signState,
  certState: state => state.user.certState,
  activityPlan: state => state.user.activityPlan,
  interviewPlan: state => state.user.interviewPlan,
  location: state => state.user.location,
  nameField: state => state.user.nameField,
  enNameField: state => state.user.enNameField,
  surname: state => state.user.surname,
  enSurname: state => state.user.enSurname,
  gender: state => state.user.gender,
  firstStep: (state) => state.user.activeStep,
  lastStep: (state) => state.user.lastStep,
  show1: (state) => state.user.show1,
  show2: (state) => state.user.show2,
  show3: (state) => state.user.show3,
  showCount: (state) => state.user.showCount,
  showNative: (state) => state.user.showNative,
  edit1: (state) => state.user.edit1,
  edit2: (state) => state.user.edit2,
  edit3: (state) => state.user.edit3,
  editCount: (state) => state.user.editCount,
  submit1: (state) => state.user.submit1,
  submit2: (state) => state.user.submit2,
  submit3: (state) => state.user.submit3
}
export default getters
